import React from "react";
import { toast } from "react-toastify";
import { css } from "glamor";
import { SimManager } from "@learningblocks/simulation-engine";
import { TimerModal } from "@learningblocks/simulations/shared-components";
import Toast from "@learningblocks/simulations/shared-components/lib/toast/Toast";
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

import TimerImage from "./images/Timer.svg";

interface OsmosisTimerProps {
  show: boolean;
  close: () => void;
}

class OsmosisTimer extends React.Component<OsmosisTimerProps> {
  makeToast = (type: string, msg: string, title: string) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px",
      }),
      progressClassName: css({
        background: color,
      }),
      position: "top-center",
      autoClose: 5000,
    });
  };

  handleStartTimer = (currentTime: number): boolean => {
    for (let i = 1; i < 7; i++) {
      const currentState = SimManager.getInstance().getInputValue("tube_" + i);

      if (
        currentState &&
        Object.prototype.hasOwnProperty.call(currentState, "currentLocation") &&
        (!currentState.currentLocation.includes("beaker") ||
          currentState.currentLocation.includes("Large"))
      ) {
        this.makeToast(
          "WARNING",
          "Please submerge tube number " + i + " before starting the timer.",
          "Submerge All Tubes"
        );
        return false;
      }
    }

    return true;
  };

  handleTimerComplete = (totalTime: number): void => {
    if (totalTime >= 1800) {
      SimManager.getInstance().updateState("timer", "set");

      setTimeout(() => {
        SimManager.getInstance().handleUpdateItems();
      }, 50);
    }
  };

  render() {
    return (
      <TimerModal
        show={this.props.show}
        close={this.props.close}
        timerImage={TimerImage}
        onStartTimer={this.handleStartTimer}
        onTimerComplete={this.handleTimerComplete}
        hourIncrement={3600}
        minuteIncrement={300}
        tickInterval={5}
        ariaLabel="A timer, which has a screen with different buttons on it."
      />
    );
  }
}

export default OsmosisTimer;
